import cloneDeep from 'lodash/cloneDeep';

export const mapToQueryObjectParams = object => {
  object = cloneDeep(object);

  Object.keys(object).forEach(key => {
    if (!object[key]) delete object[key];

    if (key === 'capabilities') {
      object[key] = object[key]
        .reduce((acc, item) => (item.checked ? [...acc, item.label.toUpperCase()] : acc), [])
        .join(',');
    }
  });

  return object;
};
